import { render, staticRenderFns } from "./IconSocial.vue?vue&type=template&id=db5910a4&scoped=true"
import script from "./IconSocial.vue?vue&type=script&lang=js"
export * from "./IconSocial.vue?vue&type=script&lang=js"
import style0 from "./IconSocial.vue?vue&type=style&index=0&id=db5910a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5910a4",
  null
  
)

export default component.exports